module.exports = __webpack_public_path__ + "img/checkered.5f33d0db.png";